import { ResultTestSchema } from '../types/result_test.schema';

export interface NormalizedSessionQuestion {
  id: string;
  answer: string | number | null;
  text: string;
}

export function normalizeSessionQuestions(rawData: Partial<ResultTestSchema>): NormalizedSessionQuestion[] {
  if (rawData === null || rawData === undefined) {
    throw new Error('sessionQuestions отсутствует или невалиден');
  }
  if (typeof rawData === 'object' && Object.keys(rawData).length === 0) {
    return [];
  }
  // если sessionQuestions — массив
  if (Array.isArray(rawData.sessionQuestions)) {
    return rawData.sessionQuestions;
  }
  // если sessionQuestions — объект с числовыми ключами
  if (rawData.sessionQuestions && typeof rawData.sessionQuestions === 'object') {
    const arr = Object.values(rawData.sessionQuestions);
    if (arr.every(q => typeof q === 'object' && q !== null && 'id' in q)) {
      return arr;
    }
  }
  // если sessionQuestions отсутствует — вернуть пустой массив
  if (!rawData.sessionQuestions) {
    return [];
  }
  throw new Error('sessionQuestions отсутствует или невалиден');
} 